import React, { useState, useEffect } from 'react';
import axios from 'axios';

/**
 * Charge une image via axios (avec le token Bearer déjà injecté par l'interceptor)
 * puis l'affiche à partir d'une objectURL. Nécessaire pour les endpoints protégés
 * qui refusent les GET anonymes déclenchés par un simple `<img src>`.
 *
 * Props:
 *  - url : URL API absolue (ex. `${API}/orders/conformateur-photo/{id}`)
 *  - alt : texte alternatif
 *  - className : classes CSS
 *  - onLoaded(url) : callback optionnel appelé avec l'objectURL une fois chargé
 */
export default function AuthImage({ url, alt = '', className = '', onLoaded, ...rest }) {
  const [src, setSrc] = useState('');
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let alive = true;
    let objectUrl = null;
    setFailed(false);
    setSrc('');
    if (!url) return () => { alive = false; };
    axios.get(url, { responseType: 'blob' })
      .then((res) => {
        if (!alive) return;
        objectUrl = URL.createObjectURL(res.data);
        setSrc(objectUrl);
        if (onLoaded) onLoaded(objectUrl);
      })
      .catch(() => { if (alive) setFailed(true); });
    return () => {
      alive = false;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [url]);

  if (failed) {
    return <div className={`flex items-center justify-center text-xs text-zinc-400 bg-zinc-100 ${className}`}>Image indisponible</div>;
  }
  if (!src) {
    return <div className={`flex items-center justify-center text-xs text-zinc-400 bg-zinc-100 ${className}`}>Chargement…</div>;
  }
  return <img src={src} alt={alt} className={className} {...rest} />;
}
